import { useAttachments } from '@/features/conversation/queries/attachments.queries';
import { FileAttachmentItem } from '@/features/messages/components/message-compose/compose-files';
import { Box, Button, Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AttachmentType } from '../../../messages/models/attachment';
import EmptyState from './empty-state';
import ErrorState from './error-state';
import LoadingState from './loading-state';

interface FileTabPanelProps {
  conversationId: string;
}

export const FileTabPanel: FC<FileTabPanelProps> = ({ conversationId }) => {
  const { t } = useTranslation();
  const { files, isLoading, isError, hasNextPage, fetchNextPage, isFetchingNextPage } = useAttachments({
    conversationId,
    contentType: AttachmentType.FILE,
    limit: 20
  });

  if (isLoading) return <LoadingState />;
  if (isError) return <ErrorState />;
  if (!files.length) return <EmptyState />;

  return (
    <Box>
      {files.map((item: any) => (
        <FileAttachmentItem
          key={item.messageId || item.id || Math.random()}
          attachment={{
            ...item.attachment,
            contentType: AttachmentType.FILE
          }}
          maxFileNameLength={30}
          mode='comfortable'
        />
      ))}
      {hasNextPage && !isFetchingNextPage && (
        <Box className='mex:pt-2 mex:text-center'>
          <Button
            variant='text'
            size='small'
            onClick={() => fetchNextPage()}
            className='mex:!text-blue-500 mex:hover:!text-blue-700'
          >
            Xem thêm
          </Button>
        </Box>
      )}

      {isFetchingNextPage && (
        <Box className='mex:pt-2 mex:text-center'>
          <Typography variant='body2' className='mex:text-gray-500'>
            {t('conversations.loading.default')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
